module.exports = __webpack_public_path__ + "static/media/ICP.aed1adfb.svg";